import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Overlay from '../shared/Overlay';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { addUser } from '../../redux/actions/userActions';
import { getSysParams } from '../../redux/actions/systemActions';
import UserAddEditForm from './addEditForm/UserAddEditForm';
import { loadAlertDeviceTypes } from '../../redux/actions/alertDeviceActions';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * The add a new user form.
 * @param {function} handleSubmit - The function to be run when the form is submitted
 * @param {object} props.location - Data from the history object used for navigation and location
 * @param {string} props.location.previous - The url of the page that called this component. This is used for the "cancel" buttons to redirect back to where the user previously was
 * @returns {object} The contents of the form
 * @description - This uses redux-form to populate and track the fields in the form. The name of the fields should match the name of the object key the field is going to be used for. For documentation of the redux-form props and functions, see https://redux-form.com
 */
export const UnconnectedAddNewUser = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const previous = state?.previous || '/users';
  console.log('AddNewUser - location.state:', state);
  console.log('AddNewUser - previous:', previous);
  const user = {
    id: '',
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    suffix: '',
    title: '',
    preferred_name: '',
    phone: '',
    makeMassnotification: false, //Boolean used in UserContactForm.js
    date_of_birth: null,
    groups: [],
    user_permissions: [],
    units: [],
    active_unit: '',
    is_active: true,
    gender: '',
    notes: '',
    preferences: null,
    photo: null,
    status: 1, //default for On Property status or first option in list
    checkin_profile: null,
    alarm_devices: [],
    alert_devices: [],
    Work_Phone_Number: '',
    Text_Message: '',
    Secondary_Phone_Number: '',
    Work_Email_Address: '',
    Personal_Email_Address: '',
    Secondary_Email_Address: '',
    
   
  };

  useEffect(() => {
    props.dispatch(loadAlertDeviceTypes());
    props.dispatch(getSysParams());
  }, []); // eslint-disable-line

  const onSubmit = (values) => {
    props.dispatch(addUser(values, navigate, previous));
  };

  return (
    <Overlay rootUrl={previous} canClose={true} data-test="add-user-overlay">
      <FormattedMessage
        id="addUser.browserTabInfo"
        defaultMessage="Users | New User"
        description="Done button">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="content-container content-container--column">
        <FormattedMessage
          id="addUser.addUserTitle"
          defaultMessage="Create New User"
          description="The title for the page to edit a unit">
          {(txt) => <h1 className="no-margin text-center">{txt}</h1>}
        </FormattedMessage>

        <hr />

        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.addUser}
          permissionMessage={true}>
          <UserAddEditForm
            previous={previous}
            data-test="add-user-form"
            user={user}
            onSubmit={onSubmit}
          />
        </AccessControl>
        
      </div>
    </Overlay>
  );
};

export default connect()(UnconnectedAddNewUser);
